import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__style_text_strikethrough",
  "use": "compose__style_text_strikethrough-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 20\" id=\"compose__style_text_strikethrough\">\n  <title>Strikethrough</title>\n  <text dominant-baseline=\"central\" font-size=\"21\" text-decoration=\"line-through\" x=\"12\" y=\"10.4\" text-anchor=\"middle\">S</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol